import {
  FormBuilderMetaFlags,
  IWidgetDirectiveType,
  isInputWidget,
} from '@framework/engine';
import { VALIDATION_VALUES_KEY } from '@framework/form';
import { minBy } from 'lodash';
import {
  IOutcomeActionDirective,
  OutcomeActionDirectiveSchema,
} from './IOutcomeActionDirective';

/**
 * Permette di aggiungere la possibilità di validare come required solo se specificato
 * dalle action di un task.
 */
export const OutcomeActionDirectiveType: IWidgetDirectiveType<IOutcomeActionDirective> =
  {
    name: 'outcomeAction',
    key: 'outcomeAction',
    allowsWidget: widget => isInputWidget(widget),
    configComponent: null,
    configSchema: OutcomeActionDirectiveSchema,
    isAlwaysApplied: true,
    formSchemaModifier: ({ widget, schema, flags, parentScope }) => {
      if (flags[FormBuilderMetaFlags.SkipValidationRules]) {
        // Se le regole di validazione non sono attive, vuol dire che
        // non è il campo "principale" del Widget, quindi non dobbiamo
        // esportarlo.
        return schema;
      }

      // Nel primo elemento del parentScope c'è il codice della dichiarazione
      const declarationId = parentScope[0]?.code;

      if (!declarationId) return schema;

      return schema.when(
        ['$outcomesConstraints', VALIDATION_VALUES_KEY],
        ([constraints, values]: any[], schema) => {
          if (!constraints) return schema;

          // Estraggo l'id dell'outcome selezionato (precedentemente impostato nei values)
          let outcomeId: string | null | undefined = values?.outcome?.id;

          // Se l'outcome non è selezionato, allora utilizzo di default quello con priorità maggiore
          if (!outcomeId) {
            outcomeId = getDefaultOutcomeKey(constraints);
          }

          if (!outcomeId) return schema.notRequired();

          const actions =
            constraints[outcomeId]?.declarations?.[declarationId] ?? [];

          if (actions.length === 0) return schema.notRequired();

          return schema;
        },
      );
    },
  };

/**
 * L'esito di deafult è quello con priorità minore (= maggiore importanza)
 */
function getDefaultOutcomeKey(constraints: any) {
  const priorityOutcome = minBy(
    Object.keys(constraints ?? {}).map(key => ({
      key,
      priority: constraints[key].priority,
    })),
    c => c.priority,
  );
  return priorityOutcome?.key;
}
